import { type HelpScoutBeacon } from './HelpScoutBeacon.types';

export default {
    openAskScreen: () => jest.fn() as jest.MockedFunction<HelpScoutBeacon['openAskScreen']>,
};
